import controller from './controller'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  formlyConfigProvider.setType({
    name: 'repeater',
    controller: controller,
  })
}
export default config